export default "__VITE_ASSET__3fa7713c__"